import {
  ChangeProposal,
  ChangeProposalDocument,
} from "../entities/change-proposal";
import {
  ChangeProposalDTO,
  ChangeProposalDocumentDTO,
  ChangeProposalWithDocumentsDTO,
} from "../dtos/change-proposal.dto";

export class ChangeProposalMapper {
  /**
   * Convert ChangeProposal entity to DTO
   */
  static toDTO(proposal: ChangeProposal): ChangeProposalDTO {
    return {
      id: proposal.id,
      projectId: proposal.project_id,
      chatId: proposal.chat_id,
      title: proposal.title,
      description: proposal.description,
      status: proposal.status,
      createdBy: proposal.created_by,
      reviewedBy: proposal.reviewed_by,
      createdAt: proposal.created_at,
      reviewedAt: proposal.reviewed_at,
    };
  }

  /**
   * Convert ChangeProposalDocument entity to DTO
   */
  static toDocumentDTO(document: ChangeProposalDocument & { documentTitle?: string }): ChangeProposalDocumentDTO {
    return {
      id: document.id,
      changeProposalId: document.change_proposal_id,
      documentId: document.document_id,
      originalContent: document.original_content,
      proposedContent: document.proposed_content,
      createdAt: document.created_at,
      documentTitle: document.documentTitle,
      processingStatus: document.processing_status,
      processingNotes: document.processing_notes,
    };
  }

  /**
   * Convert ChangeProposal with documents to DTO
   */
  static toWithDocumentsDTO(
    proposal: ChangeProposal,
    documents: Array<ChangeProposalDocument & { documentTitle?: string }>,
  ): ChangeProposalWithDocumentsDTO {
    return {
      ...this.toDTO(proposal),
      documents: documents.map(doc => this.toDocumentDTO(doc)),
    };
  }
}